var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinanceProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 114,
    height: 114
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_0_3062_19325_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3062_19325)",
    "data-figma-bg-blur-radius": 8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#610ECD",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "url(#paint0_linear_3062_19325)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 16.5,
    width: 65,
    height: 65,
    rx: 13.3,
    stroke: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 35.9667C67.7751 35.9667 68.5456 36.2525 69.1465 36.8534C70.3346 38.0414 70.3345 39.9583 69.1465 41.1464L67.0167 43.2762L62.7237 38.9833L64.8536 36.8534C65.4545 36.2525 66.225 35.9667 67.0001 35.9667Z",
    fill: "#FBFAFF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1425 45.1667L47.4804 62.8132H47.4794C46.2913 64.001 44.3745 64.0012 43.1865 62.8132C41.9987 61.6252 41.9987 59.7082 43.1865 58.5202L60.8486 40.8727L65.1425 45.1667Z",
    fill: "#FBFAFF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7 32.2133C53.7318 32.2217 53.7449 32.2348 53.7449 32.2348C53.7943 32.2897 53.7967 32.344 53.7889 32.3696L53.7869 32.3754L53.1033 34.6918L53.0623 34.8325L53.1033 34.9741L53.7869 37.3071L53.7889 37.3139C53.7969 37.3401 53.7968 37.3624 53.7928 37.3793C53.7899 37.3914 53.7829 37.4027 53.7733 37.4155C53.723 37.4564 53.6922 37.4644 53.6717 37.4653C53.6679 37.4643 53.6629 37.4631 53.6561 37.4614C53.6492 37.4596 53.6368 37.4569 53.6238 37.4536H53.6248L51.3084 36.77L51.1688 36.7289L51.0291 36.769L48.6961 37.436L48.6863 37.4389C48.6602 37.4469 48.6379 37.4468 48.6209 37.4428C48.6082 37.4398 48.5953 37.433 48.5818 37.4223C48.5399 37.3706 48.5374 37.3216 48.5447 37.2973L48.5467 37.2914L49.2293 34.975L49.2703 34.8354L49.2303 34.6957L48.5643 32.3627L48.5613 32.353L48.5545 32.3168C48.5541 32.3059 48.5554 32.296 48.5574 32.2875C48.5605 32.2746 48.5669 32.2612 48.5779 32.2475C48.6296 32.2059 48.6789 32.204 48.7029 32.2114L48.7088 32.2133L51.0252 32.8959L51.1668 32.9379L51.3084 32.8959L53.6248 32.2133L53.6307 32.2114C53.6419 32.208 53.6682 32.2051 53.7 32.2133Z",
    fill: "#FBFAFF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2326 41.5112C41.5094 41.2623 41.9181 41.1324 42.3234 41.2543L42.3244 41.2534L44.5021 41.895L46.6965 41.269V41.27C47.0302 41.1705 47.3954 41.2257 47.6838 41.4428L47.8039 41.5463L47.8215 41.5659C48.0719 41.8441 48.2036 42.2559 48.0783 42.6635L48.0773 42.6625L47.4377 44.8354L48.0607 46.9858C48.179 47.3702 48.0916 47.7996 47.7873 48.1039L47.7756 48.1157L47.7629 48.1264C47.5583 48.3054 47.2953 48.433 46.9836 48.433C46.9467 48.433 46.7978 48.4373 46.6584 48.395V48.3959L44.4826 47.7543L42.3127 48.394L42.3137 48.395C41.9294 48.5131 41.5008 48.4247 41.1965 48.1205L41.1877 48.1108L41.1779 48.101C40.9286 47.8239 40.7983 47.4142 40.9211 47.0082L41.5617 44.8305L40.9357 42.6371L40.9367 42.6362C40.8232 42.2545 40.9115 41.8313 41.2131 41.5297L41.2228 41.5209L41.2326 41.5112Z",
    fill: "#D9CDFF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6919 49.6046C72.0749 49.4887 72.5003 49.5771 72.8032 49.8799L72.813 49.8887L72.8218 49.8985C73.071 50.1754 73.2008 50.5846 73.0786 50.9903L73.0796 50.9913L72.438 53.1631L73.0952 55.3214H73.0942C73.2118 55.7054 73.1238 56.1326 72.8198 56.4366L72.7964 56.46C72.5918 56.639 72.3287 56.7666 72.0171 56.7667C71.9802 56.7667 71.8312 56.7709 71.6919 56.7286V56.7296L69.5161 56.087L67.3413 56.7296L67.3403 56.7286C66.9576 56.8439 66.5327 56.7559 66.23 56.4532L66.2202 56.4444L66.2114 56.4346C65.962 56.1575 65.8319 55.7478 65.9546 55.3419L66.5952 53.1661L65.9536 50.9913L65.9546 50.9903C65.8393 50.6076 65.9273 50.1826 66.23 49.8799L66.2388 49.8702L66.2485 49.8614C66.5254 49.6122 66.9347 49.4824 67.3403 49.6046L67.3413 49.6036L69.5161 50.2452L71.6919 49.6036V49.6046Z",
    fill: "#D9CDFF",
    stroke: "#FBFAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3062_19325",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.37398 0 0 0 0 0.193943 0 0 0 0 0.607543 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3062_19325"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3062_19325",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3062_19325_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3062_19325",
    x1: 25,
    y1: 17,
    x2: 89,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#DB6704",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB6704",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceProcess);
export default __webpack_public_path__ + "static/media/finance-process.93d23bf70e70280acbd34425c6371201.svg";
export { ForwardRef as ReactComponent };